module.exports = __webpack_public_path__ + "img/geofisica_9-16.e3657556.webp";